var map = {
	"./blog-01.jpg": 624,
	"./blog-02.jpg": 9816,
	"./blog-03.jpg": 5440,
	"./blog-04.jpg": 5015,
	"./blog-05.jpg": 3425,
	"./blog-06.jpg": 6908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7548;